import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IStatus } from '../Models/status';

@Injectable({
  providedIn: 'root'
})
export class DownloadService {

  constructor(private http: HttpClient) { }

  getData(pid: string): Observable<IStatus> {
    const param = new HttpParams().append('pid', pid);
    return this.http.get<IStatus>('/api/Downloads/GetData', { params: param, withCredentials: true });
  }
}
